import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TbDownload } from "react-icons/tb";
import { SettingRow } from "src/pages/Settings/SettingsControls";
import { getLatestAgentRelease, type AgentRelease } from "src/services/agentSyncService";
import "./agentDownloadRow.scss";

/** Download link for the Windows installer, from the latest `desktop-agent` AppVersion
 *  (backend/src/controllers/appVersionController.ts). Until one is published — or if the lookup
 *  fails — it says so instead of showing a dead button. */
export function AgentDownloadRow() {
    const { t } = useTranslation();
    const [release, setRelease] = useState<AgentRelease | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        getLatestAgentRelease()
            .then((r) => { if (!cancelled) setRelease(r); })
            .catch(() => { if (!cancelled) setRelease(null); })
            .finally(() => { if (!cancelled) setLoading(false); });
        return () => { cancelled = true; };
    }, []);

    const available = !!release?.version && !!release.downloadUrl;

    return (
        <SettingRow title={t("agentDownload.rowTitle")} description={t("agentDownload.rowDesc")} column>
            <div className="agent-download">
                {loading ? (
                    <span className="agent-download__state">{t("common.loading")}</span>
                ) : available ? (
                    <>
                        <a className="btn-outline agent-download__btn" href={release!.downloadUrl} download>
                            <TbDownload /> {t("agentDownload.btn")}
                        </a>
                        <span className="agent-download__version">{t("agentDownload.version", { version: release!.version })}</span>
                    </>
                ) : (
                    <span className="agent-download__state">{t("agentDownload.unavailable")}</span>
                )}
                <a className="agent-download__privacy" href="/legal#datenschutz-desktop-app" target="_blank" rel="noreferrer">
                    {t("agentDownload.privacy")}
                </a>
            </div>
        </SettingRow>
    );
}
